import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { ControlContainer, NgForm } from '@angular/forms';
import * as  _ from 'lodash';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';
import { Subscriber } from 'rxjs';
import { isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { WorkflowComponent } from '../../workflow.component';
import { SecurityService } from '../../../_infrastructure/Security/SecurityService';

@Component({
    selector: 'communication-detail',
    templateUrl: './communication-detail.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class CommunicationDetailComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.CommunicationDetailVM = {} as models.CommunicationDetailVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public isWorkflowPgpv: boolean = false;
  public isWorkflowIncapacity: boolean = false;

  public parentWorkflow: WorkflowComponent;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.reflectionDeadlines)
  public reflectionDeadlines: models.DimensionVM[];
   
  private subscriber: models.SubscriberInformationVM;

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, private subscriberInfoService: SubscriberInformationService, private securityService: SecurityService) {
  }

  ngOnInit(): void {
    this.cardData.emailService = this.parentWorkflow.workflowInstance.formData?.StepServiceInfo['ServiceContacts']?.emailServ2
      ?? this.parentWorkflow.workflowInstance.formData?.StepServiceInfo['ServiceContacts']?.email
      ?? "";

    this.cardData.email = this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo['SubscriberContacts']?.email ?? "";

    this.isWorkflowOnSubscriber = this.parentWorkflow.isWorkflowOnSubscriber;
    this.isWorkflowPgpv = this.parentWorkflow.isWorkflowPgpv;
    this.isWorkflowIncapacity =
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001F" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001G" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001H" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001I" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001J" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001K" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001U" ||
      this.parentWorkflow.workflowInstance.workflowCode === "PEDI001Y";

  }

  ngOnDestroy(): void {
  }

  getOrderReflectionDeadlines(): models.DimensionVM[] {

    var lst = this.reflectionDeadlines;
    if (!this.parentWorkflow.isWorkflowSubmited) {
      lst = lst.filter((v, i, a) => v.isActive );
    }

    return _.sortBy(lst, (obj) => { return parseInt(obj.code) });
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  onPrevComChanged(event: any) {
    if (!isNullOrUndefined(event) && event == "true")
      this.cardData.reflectionDeadlineCode = "5";
  }
}
